import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const columnsItems = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'deletedAt',
    label: '',
    hidden: true,
  },
  {
    name: 'value',
    label: 'Value',
    sortable: false,
  },
  {
    name: 'riskScore',
    label: 'Risk Score',
    sortable: false,
  },
  {
    name: 'code',
    label: 'Code',
    sortable: false,
    filterModalPlacement: 'right',
  },
  {
    name: 'description',
    label: 'Description',
    sortable: false,
    filterModalPlacement: 'right',
  },
];

export const columnsLabels = {
  value: 'Value',
  code: 'Code',
  description: 'Description',
};

export const schema = {
  value: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  code: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  description: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  search: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  includeRemoved: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  onlyRemoved: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'value',
    type: FilterType.TEXT,
    placeholder: 'Enter Value...',
  },
  {
    name: 'code',
    type: FilterType.TEXT,
    placeholder: 'Enter Code...',
  },
  {
    name: 'description',
    type: FilterType.TEXT,
    placeholder: 'Enter Description...',
  },
];
